export default __webpack_public_path__ + "static/media/phone-green.6358fce6.png";